import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AddressMapComponent } from './address-map.component';
import { GoogleMapsModule } from '@angular/google-maps';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AppDirectivesModule } from '../../directives';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { environment } from 'src/environments/environment';




@NgModule({
    declarations: [
        AddressMapComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        GoogleMapsModule,
        TranslateModule,
        MatToolbarModule,
        AppDirectivesModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        FormsModule,
        MatProgressSpinnerModule
    ],
    exports: [AddressMapComponent]
})
export class AddressMapModule { }
